export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.resource': 'Resources',
  'menu.resource.server': 'Server Manage',
  'menu.resource.ip-pool': 'IP Pool',
  'menu.resource.machine': 'Machine Manage',
  'menu.resource.deploy-template': 'Deploy Template',
  'menu.resource.server-template': 'Server Template',
  'menu.resource.asn': 'ASN Manage',
  'menu.resource.provider': 'Provider Manage',
  'menu.resource.ssh-key': 'SSH Key Manage',
  'menu.common-report': 'Common Reports',
  'menu.common-report.project': 'Project Summary',
  'menu.report': 'Reports',
  'menu.report.performance': 'Node Performance',
  'menu.report.traffic': 'Traffic Reports',
  'menu.report.user-report-count': 'User Report Count',
  'menu.report.user-report-daily': 'User Report Daily',
  'menu.report.perf-distribution': 'Performance Distribution',
  'menu.report.failed-nodes': 'Failed Nodes',
  'menu.report.performance-diagnosis': 'Performance Diagnosis',
  'menu.report.user-report-admin': 'User Upload',
  'menu.report.node-report-admin': 'Node Upload',
  'menu.report.node-summary-report': 'Node Summary',
  'menu.report.user-summary-report': 'User Summary',
  'menu.report.project': 'Project Summary',
  'menu.report.project-hourly': 'Project Hourly Summary',
  'menu.report.app-connection-report': 'App Connection Report',
  'menu.report.retention-revenue': 'Retention Revenue',
  'menu.ad-spend': 'Ad Spend',
  'menu.business.invite-gift-card': 'Invite Gift Cards',
  'menu.business.invite-gift-card-logs': 'Issue Logs',
  'menu.system': 'System',
  'menu.system.monitor': 'System Monitor',
  'menu.system.queue-monitor': 'Queue Monitor',
  'menu.system.version': 'Version Management',
  'menu.system.app-client': 'App Client',
  'menu.system.tag-enums': 'Tag Enums',
  'menu.business': 'Business',
  'menu.business.user-manage': 'User Manage',
  'menu.business.plan': 'Plan Manage',
  'menu.business.order': 'Order Manage',
  'menu.business.external-order-receipt': 'Receipt Orders',
  'menu.dns': 'Domain Management',
  'menu.dev': 'Dev',
  'menu.dev.nodes': 'Nodes',
  'menu.dev.agents': 'Agents',
  'menu.dev.services': 'Services',
  'menu.asset': 'Asset',
  'menu.asset.provider-accounts': 'Provider Accounts',
  'menu.asset.machines': 'Machines',
  'menu.asset.ips': 'IPs',
  'menu.asset.ssh-keys': 'SSH Keys',
  'menu.asset.scripts': 'Scripts',
  'menu.asset.operations': 'Operations',
  'menu.资源资产': 'Assets',
  'menu.资源资产.供应商账号': 'Provider Accounts',
  'menu.资源资产.机器': 'Machines',
  'menu.资源资产.IP': 'IPs',
  'menu.资源资产.SSH 密钥': 'SSH Keys',
  'menu.资源资产.脚本': 'Scripts',
  'menu.资源资产.操作记录': 'Operations',
  'menu.iam': 'IAM',
  'menu.iam.users': 'Users',
  'menu.iam.roles': 'Roles',
  'menu.iam.permissions': 'Permissions',
  'menu.iam.menus': 'Menus',
  'menu.iam.clients': 'Clients',
  'menu.iam.audit-logs': 'Audit Logs',
  'menu.business.ticket': 'Ticket Manage',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.ad': 'Ad Monetization',
  'menu.traffic-platform': 'Proxy Traffic',
  'menu.traffic-platform.dashboard': 'Proxy Traffic Dashboard',
  'menu.产品分析': 'Product Analysis',
  'menu.产品分析.全局项目总览': 'Global Overview',
  'menu.产品分析.单项目诊断': 'Project Diagnosis',
  'menu.产品分析.漏斗分析': 'Funnel Analysis',
  'menu.产品分析.漏斗分析.多项目漏斗总览': 'Multi-project Funnel Overview',
  'menu.产品分析.漏斗分析.单项目漏斗分析': 'Project Funnel Analysis',
  'menu.产品分析.漏斗分析.步骤转化诊断': 'Step Conversion Diagnosis',
  'menu.产品分析.漏斗分析.分群对比分析': 'Cohort Comparison',
  'menu.产品分析.漏斗分析.路径与流失分析': 'Path and Churn Analysis',
  'menu.产品分析.漏斗分析.事件证据明细': 'Event Evidence',
  'menu.产品分析.漏斗分析.问题与效果验证': 'Issues and Validation',
  'menu.产品分析.漏斗分析.漏斗口径快照': 'Funnel Snapshot',
  'menu.产品分析.AdMob 分析': 'AdMob Analysis',
  'menu.产品分析.Firebase 分析': 'Firebase Analysis',
  'menu.产品分析.数据对账': 'Data Reconciliation',
  'menu.产品分析.打点验收中心': 'Tracking Acceptance',
  'menu.产品分析.规范与项目配置': 'Tracking Configuration',
  'menu.产品分析.数据任务与告警': 'Data Tasks and Alerts',

  'menu.project': 'Project',
  'menu.project-card': 'Project Card',
  'menu.project.list': 'Project List',
  'menu.project.developer-panel': 'Developer Workbench',
  'menu.project.product-panel': 'Product Workbench',
  'menu.project.app-mappings': 'App Attribution Mapping',
  'menu.project.detail': 'Project Detail',
  'menu.detail': 'Detail',
  'menu.firebase-analytics': 'Firebase',
  'menu.firebase-analytics.dashboard': 'Dashboard',
  'menu.firebase-analytics.node-status': 'Node Status',
  'menu.firebase-analytics.app-open': 'App Open Analysis',
  'menu.firebase-analytics.vpn-session': 'VPN Session Analysis',
  'menu.firebase-analytics.vpn-probe': 'VPN Probe Analysis',
  'menu.firebase-analytics.api-error': 'API Error Analysis',
  'menu.firebase-analytics.events': 'Event Explorer',
  'menu.nodes': 'Nodes',
  'menu.nodes.overview': 'Overview',
  'menu.nodes.list': 'Nodes',
  'menu.nodes.agents': 'Agents',
  'menu.asset.regions': 'Regions',
  'menu.asset.zones': 'Zones',
  'menu.asset.instance-types': 'Instance Types',
  'menu.asset.images': 'Images',
  'menu.asset.security-groups': 'Security Groups',
  'menu.asset.subnets': 'Subnets',
  'menu.asset.tags': 'Tags',
  'menu.资源资产.区域': 'Regions',
  'menu.资源资产.可用区': 'Zones',
  'menu.资源资产.实例规格': 'Instance Types',
  'menu.资源资产.镜像': 'Images',
  'menu.资源资产.安全组': 'Security Groups',
  'menu.资源资产.子网': 'Subnets',
  'menu.资源资产.标签': 'Tags',
};
